import { Fragment, useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import SkeltonTableRow from "./skelton/SkeltonTableRow";
import NoItem from "./NoItem";

const Table = ({
  headingData,
  tableData,
  tableAction,
  noSpaceAction,
  renderRow,
  additionalClasses,
  isLoading = false,
  totalCount
}) => {
  const [menuOpen, setMenuOpen] = useState<number | null>(null);

  const handleMenuToggle = (rowIndex: number) => {
    setMenuOpen((prevIndex) => (prevIndex === rowIndex ? null : rowIndex));
  };

  return (
    <>
      <div className="smallTablet:overflow-x-auto smallTablet:-mx-1 smallTablet:px-1">
      <table
        className={clsx("table-auto h-max w-full text-left smallTablet:min-w-[720px]", additionalClasses)}
      >
        <thead>
          <tr className="font-medium border-b border-edge-faint">
            {headingData.map((data, index) => (
              <th
                key={index}
                className="uppercase text-light-gray font-medium text-[10px] py-2 tracking-wider"
              >
                {data.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading ? <SkeltonTableRow /> : <>
            {tableData?.map((row, rowIndex: number) => (
              <Fragment key={rowIndex}>
                {renderRow(
                  {
                    row,
                    rowIndex,
                    handleMenuToggle,
                    menuOpen,
                    tableAction,
                    noSpaceAction
                  }
                )}
              </Fragment>
            ))}
          </>}
        </tbody>
      </table>
      </div>
      {(!isLoading && !totalCount) && <NoItem title="No Users Found" desc="There's nothing to see for users" />}
    </>
  );
};

Table.propTypes = {
  headingData: PropTypes.arrayOf(
    PropTypes.shape({
      accessor: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
    })
  ).isRequired,
  tableData: PropTypes.array.isRequired,
  tableAction: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.object.isRequired,
      name: PropTypes.string.isRequired,
      actionHandler: PropTypes.func.isRequired,
    })
  ),
  noSpaceAction: PropTypes.bool,
  renderRow: PropTypes.func.isRequired,
  additionalClasses: PropTypes.string,
};

export default Table;
